export type GeneExpression = "NORMAL" | "SUPER" | "HET" | "POSSIBLE_HET" | "FIFTY_PERCENT" | "SIXTY_SIX_PERCENT";
export type GeneType = "Dominant" | "Codom" | "Recessive" | "(Line Bred)" | "(Unproven)"
export const geneExpressions = [
    { value: "NORMAL", label: "Normal" },
    { value: "SUPER", label: "Super" },
    { value: "HET", label: "Het" },
    { value: "POSSIBLE_HET", label: "Possible het" },
    { value: "FIFTY_PERCENT", label: "50% het" },
    { value: "SIXTY_SIX_PERCENT", label: "66% het" }
]
export interface Gene {
    id: number,
    gene_id: number,
    gene_name: string,
    gene_type: GeneType,
    expression: GeneExpression
    reptile: string,
}
export const blankGene: Gene = {
    gene_name: "",
    gene_id: 0,
    gene_type: "Dominant",
    id: 0,
    reptile: "",
    expression: "NORMAL",
}
export const isChanceGene = (gene: { expression: GeneExpression }) => {
    // chance genes are POSSIBLE_HET, FIFTY_PERCENT, and SIXTY_SIX_PERCENT
    return gene.expression === 'POSSIBLE_HET' || gene.expression === 'FIFTY_PERCENT' || gene.expression === 'SIXTY_SIX_PERCENT';
}